import React, { useState, useEffect } from 'react';
import { Card, CardContent, Grid,Typography, TextField, Select, MenuItem, Button, Divider, Tooltip } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { CorporateFare as CorporateFareIcon, Add,Remove, CardMembership as CardMembershipIcon, LocationOn, Email, Phone, AccountCircle, Lock, DateRange, FormatListNumbered, Person } from '@mui/icons-material';
import axios from 'axios';
import { COLORS } from '../colors';
import api from '../../Services/api';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from '@mui/material/FormControl';
import IconButton from '@mui/material/IconButton';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import Snackbar from '@mui/material/Snackbar';
import SnackbarContent from '@mui/material/SnackbarContent';
import { Link ,useNavigate} from 'react-router-dom';
import InputLabel from '@mui/material/InputLabel';
import Autorenew from '@mui/icons-material/Autorenew';


const useStyles = makeStyles({
 

  detail: {
    display: 'flex',
    alignItems: 'center',
    justifyContent:"center",
    marginBottom: 15,
  },
  
  textField: {
    width: '80%',
    '& .MuiInputLabel-root': {
      color: 'gray', // Default label color (or set to something else)
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: 'gray', // Outline color to white when not focused
      },
      '&:hover fieldset': {
        borderColor: 'gray', // Optional: Outline color on hover
      },
      '&.Mui-focused fieldset': {
        borderColor: 'black', // Optional: Outline color when focused
      },
    },
    // When the field is focused, change label color to white
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'gray',
    },
    // Text inside input area when focused
    '& .MuiOutlinedInput-input': {
      color: 'black', // Text color inside the input area when focused
    },
    // Ensure the text inside is visible when the field is not focused
    '& .MuiOutlinedInput-input.Mui-focused': {
      color: 'black', // Make text black when focused to keep it visible
    },
  },
 

});

const statesInIndia = ['Andhra Pradesh', 'Arunachal Pradesh', 'Assam', 'Bihar', 'Chhattisgarh', 'Goa', 'Gujarat', 'Haryana', 'Himachal Pradesh', 'Jharkhand', 'Karnataka', 'Kerala', 'Madhya Pradesh', 'Maharashtra', 'Manipur', 'Meghalaya', 'Mizoram', 'Nagaland', 'Odisha', 'Punjab', 'Rajasthan', 'Sikkim', 'Tamil Nadu', 'Telangana', 'Tripura', 'Uttar Pradesh', 'Uttarakhand', 'West Bengal', 'Andaman and Nicobar Islands', 'Chandigarh', 'Dadra and Nagar Haveli and Daman and Diu', 'Delhi', 'Ladakh', 'Lakshadweep', 'Puducherry'];

export default function AdminAssessor() {
  const classes = useStyles();
  const [formData, setFormData] = useState({
    companyId: '',
    stateId: '',
    placeName: '',
    CorporateId:'',
    principleEmployer: '',
    authorisedPersonName: '',
    companyEmailId: '',
    
    companyEmailId1: '',
   
    companyAddress: '',
    clientName: '',
    clientAddress:'',
    division:'',
    clientContactPersonName: '',
    clientContactPersonPhoneNumber: '',
    clientContactPersonEmailId: '',
    clientContactPersonPhoneNumber1: '',
    clientContactPersonEmailId1: '',
    assessorCompanyName: '',
    assessorPlaceName: '',
    assessorStateId: '',
    assessorAddress: '',
    assessorPinCode: '',
    site: '',
    assessorName: '',
    assessorPhoneNumber: '',
    assessorEmail: '',
    assessorPhoneNumber1: '',
    assessorEmail1: '',
    assessorUsername: '',
    assessorPassword: '',
    joiningDate: '',
    exitDate: '',

  });
  const [errors, setErrors] = useState({});
  const [clientOptions, setClientOptions] = useState([]);
  const [showPassword, setShowPassword] = React.useState(false);
  const [extraEmailAssessorVisible, setExtraEmailAssessorVisible] = useState(false);
  const [extraPhoneNumberVisible, setExtraPhoneNumberVisible] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [errorSnackbarOpen, setErrorSnackbarOpen] = useState(false);
  const [snackbarErrorMessage, setSnackbarErrorMessage] = useState('');
  const navigate=useNavigate();


const generatePassword = ( length = 12 ) => {
  const lower = 'abcdefghijklmnopqrstuvwxyz';
  const upper = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const number = '0123456789';
  const special = '!@#$%^&*()_+[]{}|;:,.<>?';
  const all = lower + upper + number + special;

  if (length < 8) throw new Error("Password length must be at least 8");

  const getRandomChar = (charset) =>
    charset.charAt(Math.floor(Math.random() * charset.length));

  // Ensure at least one from each required set
  let password = [
    getRandomChar(lower),
    getRandomChar(upper),
    getRandomChar(number),
    getRandomChar(special)
  ];

  // Fill the rest with random characters from all allowed sets
  for (let i = password.length; i < length; i++) {
    password.push(getRandomChar(all));
  }

  // Shuffle the result to avoid predictable order
  return password
    .sort(() => 0.5 - Math.random())
    .join('');
};


const handleGeneratePassword = () => {
    const newPassword = generatePassword();
    handleChange({ target: { name: 'assessorPassword', value: newPassword } });
  };

  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleAddEmailAssessor = () => {
    setExtraEmailAssessorVisible(prevState=>!prevState);
  }

  const handlePhoneNumberAssessor = () => {
    setExtraPhoneNumberVisible(prevState=>!prevState);
  }

  //  API TO FETCH ALL CLIENTS DETAILS
  useEffect(() => {
    api.client.getClients()
      .then(response => {
        setClientOptions(response.data);
      })
      .catch(error => {
        console.error('Error fetching company names:', error);
      });
  }, []);



  // API TO FETCH SELECTED CLIENT DETAILS 
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (name === 'clientName') {

      api.client.getClients().then(response => {
        const selectedClient = response.data.find(client => client.companyId === value);
        if (selectedClient) {
          const { companyAddress, clientName,clientAddress,division, principleEmployer, companyId, placeName, clientContactPersonName, authorisedPersonName,
            companyEmailId, companyEmailId1, CorporateId,assessorPhoneNumber1, assessorPhoneNumber, clientContactPersonEmailId, clientContactPersonEmailId1, pinCode, clientContactPersonPhoneNumber1, clientContactPersonPhoneNumber, stateId } = selectedClient;
          setFormData(prevState => ({
            ...prevState,
            clientName: clientName,
            clientAddress,
            division,
            companyId,
            CorporateId,
            principleEmployer,
            companyAddress,
            pinCode,
            authorisedPersonName,
            companyEmailId,
            
            companyEmailId1,
           
            placeName,
            clientContactPersonName,
            clientContactPersonEmailId,
            clientContactPersonPhoneNumber,
            clientContactPersonEmailId1,
            clientContactPersonPhoneNumber1,
            stateId,

          }));
          const error = validateField(name, value);
          setErrors(prev => ({
            ...prev,
            [name]: error,
          }));
        }
      })
        .catch(error => {
          console.error('Error fetching vendor details:', error);
        });
    }

    else {
      setFormData(prevState => ({
        ...prevState,
        [name]: value
      }));
      const error = validateField(name, value);
      setErrors(prev => ({
        ...prev,
        [name]: error,
      }));
    }
  };


  //VALIDATION
  const validateField = (name, value) => {
    const emailPattern = /^(?!.*\.\.)[a-zA-Z0-9._%+-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$/;
    const phonePattern = /^[6-9]\d{9}$/;
    const pinCodePattern = /^(?!000000$)[0-9]{6}$/;
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s])[^\s]{8,12}$/;
   const dateRegex = /^\d{4}-\d{2}-\d{2}$/;
  
    switch (name) {
      case 'clientName':
        return value ? '' : 'Please select Establishment';
  
      case 'assessorCompanyName':
        return value.trim() ? '' : 'Company name is required';
  
      case 'assessorPlaceName':
        return value.trim() ? '' : 'Place / City is required';
  
      case 'assessorAddress':
        return value.trim() ? '' : 'Company address is required';
  
      case 'assessorName':
        return value.trim() ? '' : 'Contact person name is required';
  
      case 'site':
        return value.trim() ? '' : 'Site name is required';
  
      case 'assessorEmail':
        return !value
          ? 'Email address is required'
          : emailPattern.test(value)
          ? ''
          : 'Invalid email address (e.g., text@email.com)';
  
      case 'assessorEmail1':
        return value && !emailPattern.test(value) ? 'Invalid email address' : '';
  
      case 'assessorPhoneNumber':
        if (!value) return 'Contact number is required';
        if (!phonePattern.test(value)) return 'Invalid contact number, should start with 6-9 and length should be 10 digits';

        return '';
  
      case 'assessorPhoneNumber1':
        return value && !phonePattern.test(value)
          ? 'Invalid contact number, should start with 6-9 and length should be 10 digits'
          : '';
  
      case 'assessorPinCode':
        return !value
          ? 'Pin code is required'
          : pinCodePattern.test(value)
          ? ''
          : 'Invalid Pin code format (e.g., 560001)';
  
      case 'assessorUsername':
        return value.trim() ? '' : 'Username is required';
  
      case 'assessorPassword':
        return !value
          ? 'Password is required'
          : passwordRegex.test(value)
          ? ''
          : 'Password must be 8–12 characters long, uppercase, lowercase, number, special char, no spaces';
  
      case 'joiningDate':
         if (!value) return 'Date of Joining is required';
        if (!dateRegex.test(value)) return 'Invalid date format';

        return '';
  
      case 'exitDate':
          if (!value) return 'Date of Exit is required';
        if (!dateRegex.test(value)) return 'Invalid date format';

        return '';
       
  
      case 'assessorStateId':
        return value ? '' : 'Please select State';
  
      default:
        return '';
    }
  };
  

  const validateForm = () => {
    const newErrors = {};
  
    Object.keys(formData).forEach((fieldName) => {
      const error = validateField(fieldName, formData[fieldName]);
      if (error) {
        newErrors[fieldName] = error;
      }
    });
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // ✅ returns true if no errors
  };


  //CREATING ASSESSOR PROFILE
  const handleSave = async () => {
    const isValid = validateForm();
    if (isValid) {
      let data = sessionStorage.getItem('user');
      let data1 = JSON.parse(data);
      let type = data1.type;
      try {
        if(type === 'admin'){
        const response = await api.assessor.createAssessor(formData)

        if (response.status === 400) {
          setErrorSnackbarOpen(true);
          setSnackbarErrorMessage("The username you Entered is already in use. Please enter a different one");
          
        }
        else if (response.status === 201) {
         
          setSnackbarOpen(true);
          setSnackbarMessage("Assessor Created Succesfully")
          setFormData({
            companyId: '',
            stateId: '',
            CorporateId:'',
            placeName: '',
            principleEmployer: '',
            authorisedPersonName: '',
            companyEmailId: '',
           
            companyEmailId1: '',
            pinCode:'',
           
            companyAddress: '',
            clientName: '',
            clientAddress:'',
            division:'',
            clientContactPersonName: '',
            clientContactPersonPhoneNumber: '',
            clientContactPersonEmailId: '',
            clientContactPersonPhoneNumber1: '',
            clientContactPersonEmailId1: '',
            assessorCompanyName: '',
            assessorPlaceName: '',
            assessorStateId: '',
            assessorAddress: '',
            assessorPinCode: '',
            site: '',
            assessorName: '',
            assessorPhoneNumber: '',
            assessorEmail: '',
            assessorPhoneNumber1: '',
            assessorEmail1: '',
            assessorUsername: '',
            assessorPassword: '',
            joiningDate: '',
            exitDate: '',
          })


        }
      }
      else {
        setErrorSnackbarOpen(true);
        setSnackbarErrorMessage("Only admin can create company");
        navigate('/');
            }

      }
      catch (error) {
        console.error('Error saving vendor profile:', error);
       
      }
    }
  };


  return (
    <>
       <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          
          }}
          severity="success"
          open={snackbarOpen}
          autoHideDuration={2000}
          onClose={() => setSnackbarOpen(false)}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
        >
          <SnackbarContent style={{ backgroundColor: "green" }} message={snackbarMessage} />
        </Snackbar>
        <Snackbar
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          severity="error"
          open={errorSnackbarOpen}
          autoHideDuration={2000}
          sx={{
            marginTop: '2.9%', 
            marginRight: '7%'
          }}
          onClose={() => {setErrorSnackbarOpen(false)}}
        >
          <SnackbarContent style={{ backgroundColor: "red" }} message={snackbarErrorMessage} />
        </Snackbar>
        <div style={{background:'#eeee',overflowX:'hidden'}}>
   <h4 className="p-3  text-center " style={{borderRadius:'0px 0px 0px 0px',background: 'linear-gradient(205deg, rgba(28,28,28,1) 68%, rgba(213,214,215,0) 8%)',color:'#eeee'}}>Create Assessor Profile</h4>
<div className="mt-4">
        
      
          <Grid container >
            <Grid item xs={12} sm={6}>
            <h6 className="text-secondary pb-2" style={{paddingLeft:'60px'}}>Establishment Details</h6>
        <FormControl fullWidth sx={{marginLeft:8,marginTop:2,marginBottom:2}}>
                    <InputLabel id="demo-simple-select-label">Select Establishment</InputLabel>
            <Select
              InputLabelProps={{ shrink: true }}
              className={classes.textField}
                 labelId="demo-simple-select-label"
                        id="demo-simple-select"
                            label="Select Establishment"
              value={formData.companyId}
              // sx={{border:'1px solid lightgray'}}
              onChange={handleChange}
              name="clientName"
              displayEmpty
              error={!!errors.clientName}
            >
              {/* <MenuItem value="" disabled>Select Client</MenuItem> */}
              {Array.isArray(clientOptions) && clientOptions.map((client, index) => (
                <MenuItem key={index} value={client.companyId}>
                  {client.clientName} {client.stateId}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          {errors.clientName && (
            <div className="pb-2 text-center" style={{ color: 'red', fontSize: '14px' }}>
              {errors.clientName}
            </div>
          )}

          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Address" name="clientAddress" value={formData.clientAddress} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
           <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Division" name="division" value={formData.division} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
        
          <div className={classes.detail}>
            {/* <Person className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Authorised Person" name="clientContactPersonName" value={formData.clientContactPersonName} onChange={handleChange} InputProps={{ readOnly: true }}
            />
          </div>
          <div className={classes.detail}>
            {/* <Phone className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Contact Number"  name="clientContactPersonPhoneNumber" value={formData.clientContactPersonPhoneNumber} onChange={handleChange} type='number' InputProps={{ readOnly: true }} />
          </div>
          <div className={classes.detail}>
            {/* <Email className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Email" name="clientContactPersonEmailId" value={formData.clientContactPersonEmailId} onChange={handleChange} InputProps={{ readOnly: true }} />
          </div>
          </Grid>
          <Grid xs={12} md={6}>
          <h6 className="text-secondary pb-4" style={{paddingLeft:'60px'}}>Assessor Details</h6>
          <div className={classes.detail}>
            {/* <Person className={classes.icon} /> */}
            <TextField
              InputLabelProps={{ shrink: true }}
               className={classes.textField} label="Assessor / Company Name" name="assessorCompanyName" value={formData.assessorCompanyName} onChange={handleChange} error={!!errors.assessorCompanyName}
              helperText={errors.assessorCompanyName} />
          </div>
          <FormControl fullWidth sx={{marginLeft:8,marginBottom:2}}>

<InputLabel id="demo-simple-select-label">Select State</InputLabel>
            <Select
             labelId="demo-simple-select-label"
          id="demo-simple-select"
              className={classes.textField}
              label="Select State"
              InputLabelProps={{ shrink: true }}
              // sx={{border:'1px solid lightgray'}}
              value={formData.assessorStateId}
              onChange={handleChange}
              name="assessorStateId"
              displayEmpty
              error={!!errors.assessorStateId}
            >
              {/* <MenuItem value="" disabled >Select State</MenuItem> */}
              {statesInIndia.map((state, index) => (

                <MenuItem key={index} value={state}>{state}</MenuItem>
              ))}
            </Select>
</FormControl>
          {errors.assessorStateId && (
            <div className="pb-2 text-center" style={{ color: 'red', fontSize: '14px' }}>
              {errors.assessorStateId}
            </div>
          )}
            <div className={classes.detail}>
            {/* <MyLocationIcon className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Place / City"
              InputLabelProps={{ shrink: true }}
              name="assessorPlaceName"
              value={formData.assessorPlaceName}
              onChange={handleChange}
            
              error={!!errors.assessorPlaceName}
              helperText={errors.assessorPlaceName}
            />
          </div>
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Address" name="assessorAddress" value={formData.assessorAddress} onChange={handleChange} error={!!errors.assessorAddress}
              helperText={errors.assessorAddress} />
          </div>
        
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField className={classes.textField} label="Pincode" name="assessorPinCode" value={formData.assessorPinCode} onChange={handleChange} error={!!errors.assessorPinCode}
              helperText={errors.assessorPinCode} InputLabelProps={{ shrink: true }}/>
          </div>
          <div className={classes.detail}>
            {/* <LocationOn className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Site" name="site" value={formData.site} onChange={handleChange} error={!!errors.site}
              helperText={errors.site} />
          </div>
          <div className={classes.detail}>
            {/* <Person className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              className={classes.textField} label="Contact Person" name="assessorName" value={formData.assessorName} onChange={handleChange} error={!!errors.assessorName}
              helperText={errors.assessorName} />
          </div>
          <div className={classes.detail}>
            {/* <Phone className={classes.icon} /> */}
            <TextField 
              InputLabelProps={{ shrink: true }}
              sx={{marginLeft:'42px'}} className={classes.textField} label="Contact Number" name="assessorPhoneNumber" value={formData.assessorPhoneNumber} onChange={handleChange} error={!!errors.assessorPhoneNumber}
              helperText={errors.assessorPhoneNumber} />
            <IconButton onClick={handlePhoneNumberAssessor} style={{ marginLeft: '5px' }} color="primary">
            {extraPhoneNumberVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
        </IconButton>
          </div>
          {extraPhoneNumberVisible && (
            <div className={classes.detail}>
              {/* <PhoneIphoneIcon className={classes.icon} /> */}
              <TextField className={classes.textField}
                label="Alternative Contact Number"
              
                InputLabelProps={{ shrink: true }}
                name="assessorPhoneNumber1"
                value={formData.assessorPhoneNumber1}
                onChange={handleChange}
                error={!!errors.assessorPhoneNumber1}
                helperText={errors.assessorPhoneNumber1} />

            </div>
          )}
          <div className={classes.detail}>
            {/* <Email className={classes.icon} /> */}
            <TextField sx={{marginLeft:'42px'}} className={classes.textField} label="Email" name="assessorEmail" value={formData.assessorEmail} onChange={handleChange} error={!!errors.assessorEmail}
              helperText={errors.assessorEmail}   InputLabelProps={{ shrink: true }}/>
            <IconButton onClick={handleAddEmailAssessor} style={{ marginLeft: '5px' }} color="primary">
            {extraEmailAssessorVisible ? <Remove sx={{ color: "gray" }} /> : <Add sx={{ color: "gray" }} />}
        </IconButton>
          </div>
          {extraEmailAssessorVisible   && (
            <div className={classes.detail}>
              {/* <MailOutlineIcon className={classes.icon} /> */}
              <TextField className={classes.textField}
                label="Alternative Email"
                type="email"
                name="assessorEmail1"
                InputLabelProps={{ shrink: true }}
                value={formData.assessorEmail1}
                onChange={handleChange}
                error={!!errors.assessorEmail1}
                helperText={errors.assessorEmail1} />

            </div>
          )}

          <div className={classes.detail}>
            {/* <DateRange className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Date Of Joining"
              type="date"
              name="joiningDate"
              InputLabelProps={{ shrink: true }}
              value={formData.joiningDate}
              onChange={handleChange}
              InputProps={{
                inputProps: {
                  max: formData.endDate, // Dynamically set the min date
                },
              }}
              error={!!errors.joiningDate}
              helperText={errors.joiningDate}
            />
          </div>
          <div className={classes.detail}>
            {/* <DateRange className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Date Of Exit"
              type="date"
              name="exitDate"
              value={formData.exitDate}
              onChange={handleChange}
              InputProps={{
                inputProps: {
                  min: formData.joiningDate, 
                },
              }}
          
              InputLabelProps={{
                shrink: true,
              }}
              error={!!errors.exitDate}
              helperText={errors.exitDate}
            />
          </div>
        

          <div className={classes.detail}>
            {/* <AccountCircle className={classes.icon} /> */}
            <TextField
              className={classes.textField}
              label="Username"
              name="assessorUsername"
              value={formData.assessorUsername}
              onChange={handleChange}
              InputLabelProps={{ shrink: true }}
              error={!!errors.assessorUsername}
              helperText={errors.assessorUsername}
            />
          </div>

          <div className={classes.detail}>
            {/* <Lock className={classes.icon} /> */}
            <FormControl sx={{width: '100%'}} variant="outlined">

              <TextField
              sx={{marginLeft:'10%'}}
              className={classes.textField}
                id="outlined-adornment-password"
                type={showPassword ? 'text' : 'password'}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        aria-label="toggle password visibility"
                        onClick={handleClickShowPassword}
                        onMouseDown={handleMouseDownPassword}
                        edge="end"
                      >
                        {showPassword ? <VisibilityOff sx={{color:'black'}}/> : <Visibility sx={{color:'black'}}/>}
                      </IconButton>
                      <Tooltip title="Generate Password">
                       <IconButton
                       aria-label="generate password"
                       onClick={handleGeneratePassword}
                      edge="end"
                    >
                      <Autorenew sx={{ color: 'grey' }} />
                   </IconButton>
                   </Tooltip>
                    </InputAdornment>
                  ),
                }}

                label="Password"
                InputLabelProps={{ shrink: true }}
                name="assessorPassword"
                value={formData.assessorPassword}
                onChange={handleChange}
                error={!!errors.assessorPassword}
                helperText={errors.assessorPassword}
              />
            </FormControl>

          </div>
          </Grid>
            <Grid item xs={12}>
              <button type="button" className="btn  btn-success float-end   mt-2 mb-2" style={{marginRight:'59px'}} onClick={handleSave}>
                  Create
                </button>
              </Grid>
          </Grid>
         
       
    </div>
    </div>
    </>
  )
}
